// extracted by mini-css-extract-plugin
export default {"wrapper":"headline__wrapper__yYIlX","container":"headline__container__Wq_qX","title":"headline__title__hSrA_","description":"headline__description__NMtvF"};